import { FC } from "react";
import { Button, Text, VStack } from "@chakra-ui/react";

import { formatPhoneNumber } from "../../../../utils";
import { VITE_SUPPORT_PHONE_NUMBER } from "../../../../ENV.ts";

interface Props {
  message: string;
  onClose: () => void;
}

export const MainPageModal: FC<Props> = ({ message, onClose }) => {
  const phoneNumber = formatPhoneNumber(VITE_SUPPORT_PHONE_NUMBER);

  return (
    <VStack spacing={0} pt="12px" px="4px">
      <Text variant="brand" fontFamily="Normalidad Medium Var" fontSize="20px" pb="10px" textAlign="center">
        {message}
      </Text>

      <Text fontSize="sm">Обратитесь в поддержку</Text>
      <Text fontSize="sm" mb="22px">{phoneNumber}</Text>

      <Button w="100%" pt="1px" onClick={onClose}>
        Закрыть
      </Button>
    </VStack>
  );
};
